import { render, staticRenderFns } from "./page8.vue?vue&type=template&id=54d83f46&scoped=true&"
import script from "./page8.vue?vue&type=script&lang=js&"
export * from "./page8.vue?vue&type=script&lang=js&"
import style0 from "./page8.vue?vue&type=style&index=0&lang=less&"
import style1 from "./page8.vue?vue&type=style&index=1&id=54d83f46&lang=less&scoped=true&"
import style2 from "./page8.vue?vue&type=style&index=2&id=54d83f46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d83f46",
  null
  
)

export default component.exports